/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/**
 * @const
 * @enum {string}
 */
const ImageAlignment = Object.freeze({
  LEFT_TOP: 'Left Top',
  LEFT_CENTER: 'Left Center',
  LEFT_BOTTOM: 'Left Bottom',
  RIGHT_TOP: 'Right Top',
  RIGHT_CENTER: 'Right Center',
  RIGHT_BOTTOM: 'Right Bottom',
  CENTER_TOP: 'Center Top',
  CENTER: 'Center',
  CENTER_BOTTOM: 'Center Bottom'
})
export default ImageAlignment
// RESERVE BELOW
